module.exports = __webpack_public_path__ + "img/yellow-ink.f663e28c.png";